var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalWithTabs',{attrs:{"show":_vm.showNotic,"tabs":_vm.tabs},on:{"close":function($event){return _vm.closeModal()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }